module.exports = __webpack_public_path__ + "static/media/locationResult.89cceac1.svg";